/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_Item_LawfulInputs */

const en_terms_section_4_item_lawful = /** @type {(inputs: Terms_Section_4_Item_LawfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use it lawfully and in line with these terms.`)
};

const lv_terms_section_4_item_lawful = /** @type {(inputs: Terms_Section_4_Item_LawfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lietot to likumīgi un saskaņā ar šiem noteikumiem.`)
};

/**
* | output |
* | --- |
* | "Use it lawfully and in line with these terms." |
*
* @param {Terms_Section_4_Item_LawfulInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_item_lawful = /** @type {((inputs?: Terms_Section_4_Item_LawfulInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_Item_LawfulInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_item_lawful(inputs)
	return en_terms_section_4_item_lawful(inputs)
});